import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  min-width: 40%;
  max-width: 90%;
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  padding: ${({ theme }) => theme.landingSpacing.lg};
  display: flex;
  flex-direction: column;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.18);
  z-index: 10000;
  animation: slideDown 0.2s ease;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 92%;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.landingSpacing.md};
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 1.4;
  color: ${({ theme }) => theme.landing.text};
`;

export const ModalCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  background: transparent;
  color: ${({ theme }) => theme.landing.textSecondary};
  cursor: pointer;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
    color: ${({ theme }) => theme.landing.text};
  }
`;

export const ModalBody = styled.div`
  padding: ${({ theme }) => theme.landingSpacing.sm} 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.landingSpacing.sm};
  margin-top: ${({ theme }) => theme.landingSpacing.lg};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};
`;

export const InputLabel = styled.label`
  font-weight: 500;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const TextInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 ${({ theme }) => theme.landingSpacing.md};
  border: 1px solid
    ${({ theme, $hasError }) => ($hasError ? theme.landing.errorColor : theme.landing.cardBorder)};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  background: ${({ theme }) => theme.landing.navbarBg};
  color: ${({ theme }) => theme.landing.text};
  font-size: 0.95rem;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.landing.text};
  }

  &::placeholder {
    color: ${({ theme }) => theme.landing.textSecondary};
  }
`;

export const ErrorText = styled.p`
  font-size: 0.8rem;
  color: ${({ theme }) => theme.landing.errorColor};
  margin: 0;
`;

export const ModalCancelButton = styled.button`
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.lg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  background: transparent;
  color: ${({ theme }) => theme.landing.text};
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }
`;

export const ModalSubmitButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.lg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  border: none;

  background: ${({ theme }) => theme.landing.buttonBg};
  color: #fff;
  font-weight: 500;
  font-size: 0.9rem;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
export const PasswordInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const PasswordToggleButton = styled.button`
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.landing.textSecondary};
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.landing.text};
  }
`;

export const PolicyList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PolicyItem = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  line-height: 1.4;
  color: ${({ theme, $passed }) =>
    $passed ? theme.landing.successColor || '#16a34a' : theme.landing.textSecondary};
  transition: color 0.15s ease;

  svg {
    flex-shrink: 0;
  }
`;
